export interface SuiviReclamation {
    id: number;
    description: string;
    etat: string;
    dateEmission: string;
    emetteur: string;
    destinataire: string;
    dateCloture: string;
}

export enum EtatReclamation {
    aQualifier = 'A_QUALIFIER',
    aTraiter = 'A_TRAITER',
    enTraitement = 'EN_TRAITEMENT',
    cloturee = 'CLOTUREE'
}

export interface HistoriqueReclamation {
    date: string;
    description: string;
    etat: string;
    typeActionId: number;
}
